import PartialForm from './partial-form';

export const defaultDataProp = 'data';
export const defaultErrorsProp = 'error';

export default class EntityForm extends PartialForm {
  dataProp = defaultDataProp;
  errorsProp = defaultErrorsProp;

  getFormValue(path) {
    return path ? this.resolveStatePath(`${this.dataProp}.${path}`) : this.state[this.dataProp];
  }

  setForm(value, cb) {
    return this.setState({ [this.dataProp]: value }, cb);
  }

  setFormValue(prop, value, cb) {
    return this.setState(state => ({
      [this.dataProp]: { ...state[this.dataProp], [prop]: value }
    }), cb);
  }

  setFormError(prop, value, cb) {
    return this.setState(state => ({
      [this.errorsProp]: { ...state[this.errorsProp], [prop]: value }
    }), cb);
  }

  inputHasError(name) {
    return this.hasInput(name) ? !!this.state[this.errorsProp][name] : false;
  }

  getFormError(name) {
    return name ? this.state[this.errorsProp][name] : this.state[this.errorsProp];
  }

  treatFormError = error => {
    console.error('form error', error);
    const fileErrors = ['unsupported_file', 'no_file'];

    const blacklistErrors = [
      'query not submitted for analysis - Contact central AngelLira'
    ];

    if (error.response && error.response.data.error === 'upload_size_exceded') {
      this.enqueueSnackbar(
        `Não foi possível enviar a foto do documento,
         o arquivo excede o tamanho máximo previsto de 2MB.`,
        { variant: 'error' }
      );
    } else if (error.response && fileErrors.includes(error.response.data.error)) {
      this.enqueueSnackbar(
        'Não foi possível enviar a foto do documento, tente novamente.',
        { variant: 'error' }
      );
    } else if (error.response && error.response.status === 422 && error.response.data.details) {
      error.response.data.details.forEach(err => {
        console.log('validation error', err.context.key, err.message);

        this.setFormError(err.context.key, 'confira as informações neste campo');
      });

      this.enqueueSnackbar(
        'Confira se as informações requisitadas nos campos foram informadas corretamente',
        { variant: 'error' }
      );
    } else if (blacklistErrors.includes(error?.response?.data?.error)) {
      this.enqueueSnackbar(
        'Consulta não enviada para análise - Contate a central AngelLira',
        { variant: 'error' }
      );
    } else {
      this.enqueueSnackbar(
        `Não foi possível salvar: ${error}`,
        { variant: 'error' }
      );
    }
  }

  extractFromEvent({ target: { value } }) { return value; }
  extractInnerForm(_, x) { return x; }

  updateForm = (_ev, data) => this.setState(state => ({
    [this.dataProp]: { ...state[this.dataProp], ...data }
  }));

  handleFormError = (ev, errors) => this.setState(s => ({
    [this.errorsProp]: {
      ...s[this.errorsProp],
      ...errors
    }
  }));
}
